<template>
  <div>
    <div class="mt-4 mb-4">
      <!--Absence modal -->
      <absence-modal
        :edit="modeDisplay === 'edit'"
        :employes="employes"
        :equipe="equipe"
        :modalTitle="titleModalAbsence"
        :type_absences="type_absences"
        :propForm="form"
        :modalID="modalAbsence"
        @submit="submitAbsence"
        @closeModal="closeModal"
      />

      <div class="row">
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-custom-primary"
                @click="showAbsenceModal(null)"
              >
                <i class="fas fa-plus"></i>
                Signaler absence
              </button>

              <button
                type="button"
                class="btn btn-danger ml-4"
                @click.prevent="deleteAllSelectionAbsence"
                v-show="isSelectAbsence"
              >
                <i class="fas fa-trash"></i>
                Supprimer
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <DataTable
                ref="datatable"
                @onSelect="onSelectAbsenceRows"
                @onRowShow="showAbsenceModal"
                @onRowEdit="editAbsenceModal"
                @onRowsDelete="deleteAbsenceRows"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/absence';
import NETTOYAGE_URL from '@/http/nettoyage';
import DataTable from '../components/DataTable.vue';
import AbsenceModal from '../components/AbsenceModal.vue';
import names from '@/constants/routes/chantier/absence';

import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

import From from 'vform';
export default {
  data() {
    return {
      form: new From({
        commentaire: '',
        emplye: null,
        remplacant: null,
        type_absence: null,
      }),
      equipe: [],
      employes: [],
      type_absences: [],
      routes: names,

      modeDisplay: 'create',
      titleModalAbsence: 'Ajout de nouvelle absence',
      isSelectAbsence: false,
      modalAbsence: 'modal-absence',
    };
  },
  components: {
    DataTable,
    AbsenceModal,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('nettoyage', ['setCurrentNettoyage', 'getNettoyage']),
    /**
     * Modal note
     */
    async showAbsenceModal(id) {
      if (id) {
        return this.$router.push({
          name: this.routes.show,
          params: { id },
        });
        // this.titleModalAbsence = "Aperçu d'une absence";
        // this.form.reset();
        // this.form.clear();
        // this.modeDisplay = 'show';
        // await window.axios
        //   .get(URL.ABSENCE + '/' + id)
        //   .then((resp) => {
        //     let data = resp.data.absence;
        //     this.form.employe = data.employe;
        //     this.form.remplacant = data.remplacant;
        //     this.form.type_absence = data.type_absence;
        //     this.form.commentaire = data.commentaire;
        //     this.form.auteur = data.auteur;
        //     this.form.employe_id = data.employe_id;
        //     this.form.remplacant_id = data.remplacant_id;
        //   })
        //   .catch();
      } else {
        await window.axios
          .get(NETTOYAGE_URL.GET_ABSENCE_REQUIREMENTS(this.currentNettoyage.id))
          .then((resp) => {
            this.employes = resp.data.employes;
            this.type_absences = resp.data.type_absences;
            this.equipe = resp.data.equipe;
          });
        this.modeDisplay = 'create';
        this.titleModalAbsence = 'Ajout de nouvelle absence';
        this.form.reset();
        this.form.clear();
      }

      await this.$bvModal.show(this.modalAbsence);
    },
    async editAbsenceModal(id) {
      this.titleModalAbsence = "Edition d'une absence";
      this.form.reset();
      this.form.clear();
      this.modeDisplay = 'edit';

      await window.axios
        .all([
          window.axios.get(URL.ABSENCE + '/' + id, { params: { edit: true } }),
          window.axios.get(
            NETTOYAGE_URL.GET_ABSENCE_REQUIREMENTS(this.currentNettoyage.id),
            {
              params: { edit: true },
            }
          ),
        ])
        .then(
          window.axios.spread((resp, resp2) => {
            // Object.assign(this.form, resp.data.horaire);
            let data = resp.data.absence;
            this.form.id = data.id;
            this.form.employe = data.employe;
            this.form.remplacant = data.remplacant;
            this.form.type_absence = data.type_absence;
            this.form.commentaire = data.commentaire;

            this.employes = resp2.data.employes;
            this.type_absences = resp2.data.type_absences;
            this.equipe = resp2.data.equipe;
          })
        )
        .catch();

      await this.$bvModal.show(this.modalAbsence);
    },
    submitAbsence(form) {
      if (form.id) {
        //update
        form
          .put(URL.ABSENCE + '/' + form.id)
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);
            this.setCurrentNettoyage(resp.data.nettoyage);
            this.$bvModal.hide(this.modalAbsence);
            this.reset();
            this.$refs.datatable.loadItems();
          })
          .catch((err) => {
            form.errors.set('message', err.response.data.message);
            this.$bvModal.show(this.modalAbsence);
          })
          .finally(() => {
            this.form = form;
          });
      } else {
        //store
        form
          .post(NETTOYAGE_URL.ABSENCE(this.currentNettoyage.id))
          .then((resp) => {
            this.showSimpleAlerte('top-end', 'success', resp.data.message);
            this.setCurrentNettoyage(resp.data.nettoyage);
            this.$bvModal.hide(this.modalAbsence);
            form.reset();
            form.clear();
            this.$refs.datatable.loadItems();
          })
          .catch((err) => {
            form.errors.set('message', err.response.data.message);
            this.$bvModal.show(this.modalAbsence);
          })
          .finally(() => {
            this.form = form;
          });
      }
    },
    onSelectAbsenceRows(isSelectAbsence) {
      this.isSelectAbsence = isSelectAbsence;
    },
    deleteAllSelectionAbsence() {
      this.deleteAbsenceRows(this.$refs.datatable.idsRowsSelected);
    },
    deleteAbsenceRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.ABSENCE, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.getNettoyage({ id: this.currentNettoyage.id }).then(() =>
                  this.$refs.datatable.loadItems()
                );
                this.isSelectAbsence = false;
              })
              .catch();
          }
        });
      }
    },

    /** FIN */

    reset() {
      this.form.reset();
      this.form.clear();
    },

    init() {
      this.reset();
    },
    closeModal() {
      this.reset();
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      if (modalId === this.modalAbsence) {
        this.reset();
      }
    });
    this.init();
  },
  computed: {
    ...mapGetters('nettoyage', ['currentNettoyage', 'chantier']),
  },
};
</script>

<style scoped></style>
